import { ScheduleWBSsBase } from './base/schedule-w-b-ss-base';

export class ScheduleWBSs extends ScheduleWBSsBase { }